import React from 'react'
import { slugs } from '@/constants/slugs'
import { getProjectStyle, createContactSupportAnswer } from '../shared'
import { GiveawayFaq } from '../types'

export const getHomesteadFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) =>
      t('giveawayHowDoIenterHomesteadSeries', 'How do I enter The Homestead Season 1 Escape and Evade Giveaway?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.david)}>
        {t(
          'homesteadSeason1HowDoIEnterAnswer',
          'Join the Angel Guild and watch Homestead: The Movie, episodes of Homestead: The Series or episodes of Homestead: Family Survival. Every Homestead episode or movie you watch will give you entries.',
        )}
      </span>
    ),
  },
  {
    key: 'doIneedAGuildMembership',
    question: (t) => t('doINeedAGuildMembershipQuestion', 'Do I need to be a Guild member to enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'doINeedToBeAGuildMemberAnswer',
          'No. While being a Guild member and watching is the easiest way to enter, you can also enter by mail without purchase. See the Official Rules for instructions on free entry options.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhoCanEnter', 'Who can enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorWhoCanEnterAnswer',
          'The giveaway is open to legal residents of the 50 United States (excluding NY and FL) and the\n' +
            'District of Columbia, who are at least the age of majority in their state at the time of entry.',
        )}
      </span>
    ),
  },

  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.senior),
  },
]
